import {
    apiRequest,
    orangtuaCreate,
    masterRegion,
    orangtuaListPilihan
} from "../../../../../../services/adapters/kepegawaian/orangtuaService"

class CreateRepository {

    fetchRegionCountries = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", orangtuaCreate, {
            body: query
        }, true)
    }

    fetchPosition = async (query) => {
        return await apiRequest("post", orangtuaListPilihan, {
            body: query
        }, true)
    }
}

export default CreateRepository